import React from 'react';

export const AssessmentTool: React.FC = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Site Assessment Tool</h2>
        <p className="text-sm text-gray-600">
          Evaluate potential tree planting locations using environmental data and site conditions.
        </p>
      </div>

      <div className="flex-1 p-6 space-y-6">
        {/* Instructions */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="text-sm font-medium text-blue-800 mb-2">How to Use</h3>
          <ol className="text-sm text-blue-700 space-y-1">
            <li>1. Click anywhere on the map to assess that location</li>
            <li>2. Review the environmental factors and overall score</li>
            <li>3. View recommended tree species for the site</li>
            <li>4. Generate a detailed assessment report</li>
          </ol>
        </div>

        {/* Assessment Factors */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Assessment Factors</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
              <div>
                <div className="text-sm font-medium text-gray-900">Heat Island Intensity</div>
                <div className="text-xs text-gray-500">Urban heat island effects and temperature</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
              <div>
                <div className="text-sm font-medium text-gray-900">Flood Risk</div>
                <div className="text-xs text-gray-500">FEMA flood zone classifications</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
              <div>
                <div className="text-sm font-medium text-gray-900">Environmental Justice</div>
                <div className="text-xs text-gray-500">Community demographics and equity</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <div>
                <div className="text-sm font-medium text-gray-900">Tree Density</div>
                <div className="text-xs text-gray-500">Existing tree coverage in the area</div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Assessment */}
        <div className="card p-4">
          <h3 className="text-sm font-medium text-gray-900 mb-3">Quick Assessment</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Enter Address</label>
              <input
                type="text"
                placeholder="123 Main St, Hackensack, NJ"
                className="input-field"
              />
            </div>
            <button className="btn-primary w-full">
              Assess Address
            </button>
          </div>
        </div>

        {/* Assessment History */}
        <div>
          <h3 className="text-sm font-medium text-gray-900 mb-3">Recent Assessments</h3>
          <div className="space-y-2">
            {[
              { address: 'Main St & 1st Ave', score: 85, time: '2 hours ago' },
              { address: 'Central Park entrance', score: 72, time: '1 day ago' },
              { address: 'River Rd near bridge', score: 91, time: '3 days ago' },
            ].map((assessment, index) => (
              <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <div>
                  <div className="text-sm font-medium text-gray-900">{assessment.address}</div>
                  <div className="text-xs text-gray-500">{assessment.time}</div>
                </div>
                <div className={`
                  px-2 py-1 rounded text-xs font-medium
                  ${assessment.score >= 80 ? 'bg-green-100 text-green-800' :
                    assessment.score >= 60 ? 'bg-yellow-100 text-yellow-800' :
                    'bg-red-100 text-red-800'
                  }
                `}>
                  {assessment.score}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
